import InstanceLogs from "./InstanceLogs";

export default InstanceLogs;
